import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { Subscription } from 'rxjs';
import { TextHelper } from 'src/app/utils/text-helper';
import { RegisterShared } from 'src/app/presentation/general/shared/register-shared';
import { GenerateShared } from 'src/app/presentation/general/shared/generate-shared';
import { WeightLogService } from 'src/app/data/repository/plan-repository/weight-log.service';
import { GenerateDataService } from 'src/app/data/repository/generate-repository/generate-data.service';

@Component({
  selector: 'app-weight',
  templateUrl: './weight.component.html',
  styleUrls: ['./weight.component.scss'],
})
export class WeightComponent implements OnInit, OnDestroy {
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;
  @Input() type: string;
  @Input() isDetail = false;
  @Input() Redesign: boolean = false;

  fractionalWeight: string;
  decimalWeight: string;
  secondInputText = '';
  hasError = false;
  default = 89;
  defaultDecimal = 0;
  weights: number[] = [];
  decimals: number[] = [];
  currentWeight: number;
  currentDecimal: number;
  subscription: Subscription;
  weightOfset: number;
  decimalOfset: number;
  constructor(
    private submitButtonShared: SubmitButtonShared,
    private textHelper: TextHelper,
    private registerShared: RegisterShared,
    private generateShared: GenerateShared,
    private weightLogService: WeightLogService,
    private generateDataService: GenerateDataService
  ) {
    this.setDefaultDate();

    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (this.isDetail) {
          if (
            clicked &&
            this.type === 'start' &&
            this.pageNumber === this.currentPageNumber
          ) {
            const dec = this.decimals[this.currentDecimal];
            const frac = this.weights[this.currentWeight];
            const weight = (frac * 10 + dec) / 10;
            this.generateShared.weight = weight;
            console.log(weight);

            this.generateShared.closeOverviewDetailAndChangeDifficulty();
          }
        } else {
          if (clicked && this.pageNumber === this.currentPageNumber) {
            switch (this.type) {
              case 'current': {
                const dec = this.decimals[this.currentDecimal];
                const frac = this.weights[this.currentWeight];
                const weight = (frac * 10 + dec) / 10;
                this.registerShared.weight = weight;

                this.registerShared.nextPage();
                break;
              }
              case 'start': {
                const dec = this.decimals[this.currentDecimal];
                const frac = this.weights[this.currentWeight];
                const weight = (frac * 10 + dec) / 10;
                this.generateShared.weight = weight;
                console.log(weight);

                this.generateShared.nextPage();

                break;
              }
            }
          }
        }
      }
    );

    this.submitButtonShared.activateNextButton(true);
    this.registerShared.registerActivateButton(3);
  }

  ngOnInit() {
    console.log(this.type);

    if (this.type === 'start') {
      if (this.isDetail) {
        let weight;
        this.generateDataService.getGenerate().then((res) => {
          weight = res.weight;
          this.currentWeight = this.weights.findIndex(
            (index) => index == Math.floor(weight)
          );
          this.currentDecimal = this.decimals.findIndex(
            (index) => Math.round((weight - Math.floor(weight)) * 10) == index
          );
          this.selectItems(this.currentWeight, 'weight');
          this.selectItems(this.currentDecimal, 'decimal');
        });
      } else {
        this.weightLogService.getCurrentWeight().then((res) => {
          if (res.isSuccess()) {
            const weight = res.getData().getWeightLog().weight;
            // const data = Math.round((weight - Math.floor(weight)) * 10);
            this.currentWeight = this.weights.findIndex(
              (index) => index == Math.floor(weight)
            );
            this.currentDecimal = this.decimals.findIndex(
              (index) => index == Math.round((weight - Math.floor(weight)) * 10)
            );

            console.log(weight);

            this.selectItems(this.currentWeight, 'weight');
            this.selectItems(this.currentDecimal, 'decimal');
          }
        });
      }
    } else {
      this.currentWeight = this.weights.findIndex(
        (index) => this.default == index
      );
      this.currentDecimal = this.decimals.findIndex((index) => 0 == index);
      console.log(this.currentDecimal);

      this.selectItems(this.currentWeight, 'weight');
      this.selectItems(this.currentDecimal, 'decimal');
    }
  }

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  selectItems(itemIndex: number, itemId: string) {
    const offset = (itemIndex - 2) * -40;

    if (itemId == 'weight') {
      this.weightOfset = offset;
      document.getElementById('weight').style.top = this.weightOfset + 'px';
    }
    if (itemId == 'decimal') {
      this.decimalOfset = offset;
      document.getElementById('decimal').style.top = this.decimalOfset + 'px';
    }
  }
  setDefaultDate() {
    this.weights = Array.from({ length: 271 }, (v, i) => {
      return 30 + i;
    });
    this.decimals = Array.from({ length: 10 }, (v, i) => {
      return i;
    });
  }
  swipe(swipe: string, item: string, event) {
    if (swipe == 'swipeup') {
      this.nextSlide(item, event.velocity);
    } else if (swipe == 'swipedown') {
      this.perviousSlide(item, event.velocity);
    }
  }
  nextSlide(item: string, velocity: number) {
    velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
    if (item == 'weight') {
      if (
        this.currentWeight >= 0 &&
        this.currentWeight <= this.weights.length
      ) {
        if (this.currentWeight + velocity >= this.weights.length) {
          this.currentWeight = this.weights.length - 1;
          this.selectItems(this.currentWeight, 'weight');
        } else {
          this.currentWeight = this.currentWeight + velocity;
          this.selectItems(this.currentWeight, 'weight');
        }
      }
    } else if (item == 'decimal') {
      if (
        this.currentDecimal >= 0 &&
        this.currentDecimal <= this.decimals.length
      ) {
        if (this.currentDecimal + velocity >= this.decimals.length) {
          this.currentDecimal = this.decimals.length - 1;
          this.selectItems(this.currentDecimal, 'decimal');
        } else {
          this.currentDecimal = this.currentDecimal + velocity;
          this.selectItems(this.currentDecimal, 'decimal');
        }
      }
    }
  }
  perviousSlide(item: string, velocity: number) {
    velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
    if (item == 'weight') {
      if (this.currentWeight > 0 && this.currentWeight <= this.weights.length) {
        if (this.currentWeight - velocity <= 0) {
          this.currentWeight = 0;
          this.selectItems(this.currentWeight, 'weight');
        } else {
          this.currentWeight = this.currentWeight - velocity;
          this.selectItems(this.currentWeight, 'weight');
        }
      }
    }
    if (item == 'decimal') {
      if (
        this.currentDecimal > 0 &&
        this.currentDecimal <= this.decimals.length
      ) {
        if (this.currentDecimal - velocity <= 0) {
          this.currentDecimal = 0;
          this.selectItems(this.currentDecimal, 'decimal');
        } else {
          this.currentDecimal = this.currentDecimal - velocity;
          this.selectItems(this.currentDecimal, 'decimal');
        }
      }
    }
  }
}
